import {subscriptionKind, subscriptionStatuses} from '../constants';

const timestamp = value => {
  const parsed = new Date(value).getTime();
  return Number.isNaN(parsed) ? null : parsed;
};

export const subscriptionIsActive = (subscription, now = new Date()) => {
  const start = timestamp(subscription && subscription.created);
  const expiry = timestamp(subscription && subscription.expiry);
  const current = now.getTime();
  return expiry !== null && (start === null || start <= current) && current <= expiry;
};

export const specialEventSubscriptionStatus = (subscriptions, event, now = new Date()) => {
  const rows = subscriptions && Array.isArray(subscriptions.subscriptions) ? subscriptions.subscriptions : [];
  if (!event) {
    return {status: subscriptionStatuses.canRequestEvent};
  }

  const unlimited = rows.find(subscription => (
    subscription.kind === subscriptionKind.rtvUnlimited && subscriptionIsActive(subscription, now)
  ));
  if (unlimited) {
    return {status: subscriptionStatuses.unlimited};
  }

  const dedicated = rows.find(subscription => (
    subscription.kind === subscriptionKind.rtvDedicated &&
    subscription.partner === event.uid &&
    subscription.rtv_channel_id === event.rtvChannelId &&
    subscriptionIsActive(subscription, now)
  ));
  if (dedicated) {
    return {status: subscriptionStatuses.valid};
  }

  const eventStart = timestamp(event.startDatetime);
  const eventEnd = timestamp(event.endDatetime);
  const special = rows.find(subscription => (
    subscription.kind === subscriptionKind.rtvEvent &&
    subscription.partner === event.uid &&
    subscription.rtv_channel_id === event.rtvChannelId &&
    (
      subscription.eventId !== null && subscription.eventId !== undefined
        ? Number(subscription.eventId) === Number(event.id)
        : timestamp(subscription.created) === eventStart &&
          timestamp(subscription.expiry) === eventEnd
    )
  ));
  if (special && subscriptionIsActive(special, now)) {
    return {status: subscriptionStatuses.valid};
  }
  if (special && eventStart !== null && now.getTime() < eventStart) {
    return {status: subscriptionStatuses.scheduledEvent};
  }
  if (eventEnd !== null && now.getTime() > eventEnd) {
    return {status: subscriptionStatuses.expired};
  }
  return {status: subscriptionStatuses.canRequestEvent};
};

export const specialEventSubscriptionIncludesVideo = (subscription, video, channelIds, now = new Date()) => {
  if (
    !subscription ||
    subscription.kind !== subscriptionKind.rtvEvent ||
    !video ||
    video.event !== true ||
    !Array.isArray(channelIds) ||
    !channelIds.map(Number).includes(Number(subscription.rtv_channel_id)) ||
    !subscriptionIsActive(subscription, now)
  ) {
    return false;
  }
  const videoAt = timestamp(video.timestamp);
  const eventStart = timestamp(subscription.contentStartsAt || subscription.created);
  const eventEnd = timestamp(subscription.contentEndsAt || subscription.expiry);
  return videoAt !== null && eventStart !== null && eventEnd !== null
    && eventStart <= videoAt && videoAt <= eventEnd;
};

export const shouldPollRtvVideos = videos => (
  Array.isArray(videos) && videos.some(video => video && video.videoComplete === false)
);

export const rtvChannelIsFree = channel => Boolean(channel) && (
  Number(channel.rtvPrice || 0) === 0 &&
  Number(channel.rtvPriceMembership || 0) === 0 &&
  (
    typeof channel.hasPaidSpecialEvents === 'boolean'
      ? channel.hasPaidSpecialEvents === false
      : Number(channel.rtvPriceEvent || 0) === 0
  )
);

export const specialEventPriceCents = (event, channel) => {
  if (event && event.price !== null && event.price !== undefined) {
    return Number(event.price);
  }
  return Number((channel && channel.rtvPriceEvent) || 0);
};

export const specialEventIsFree = (event, channel) => specialEventPriceCents(event, channel) === 0;
